import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {
    return (
        <Box sx={{ bgcolor: 'background.paper', py: 6, mt: 'auto' }}>
            <Container maxWidth="lg">
                <Grid
                    container
                    spacing={4}
                    justifyContent="center"
                >
                    <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
                        <Typography variant="h6" color="text.primary" gutterBottom>
                            Bağlantılar
                        </Typography>
                        <MuiLink
                            component={RouterLink}
                            to="/"
                            color="text.secondary"
                            display="block"
                        >
                            Ana Sayfa
                        </MuiLink>
                        <MuiLink
                            component={RouterLink}
                            to="/gizlilik-politikasi"
                            color="text.secondary"
                            display="block"
                        >
                            Gizlilik Politikası
                        </MuiLink>
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{ textAlign: 'center' }}>
                        <Typography variant="h6" color="text.primary" gutterBottom>
                            İletişim
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'center' }}>
                            <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />
                            <MuiLink
                                href="mailto:info@ursamer.com"
                                color="text.secondary"
                                underline="hover"
                            >
                                info@ursamer.com
                            </MuiLink>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <PhoneIcon sx={{ mr: 1, color: 'text.secondary' }} />
                            <MuiLink
                                color="text.secondary"
                                underline="hover"
                            >
                                +90 544 101 96 54
                            </MuiLink>
                        </Box>
                    </Grid>
                </Grid>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }}>
                    © {new Date().getFullYear()} Ursamer. Tüm hakları saklıdır.
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;